// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetEvents = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        events: [],
        error: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        getEventsHandler: async function() {

            /*
            **  Reset the events
            **  @prop: @here
            */

            this.resetEvents()
            .then(() => {

                /*
                **  Get the events for the invoice
                **  @method: @here
                */

                if (!this.error) this.getEvents();

            });

        },

        handleError: function() {

            /* 
            ** Display error message
            ** @service: @Window/SweetAlert
            */

            this.$swal('Uh Oh!', 'We ran into a problem trying to get the events for this invoice.', 'error');

        },

        resetEvents: async function() {

            /*
            **  Reset the events prop
            **  @prop: @here
            */

            try {

                this.events = [];

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Resetting the events prop while getting the invoice events.',
                    errorType: 'Application',
                    section: 'Events/Invoice-Events',
                    uid: 'LpaWi6XCEwNnfhCpmDMA',
                    error: e
                });

            }

        },

        getEvents: function() {

            /*
            **  Get the snapshot
            **  @service: @Firebase/Firestore
            */

            try {

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').orderBy('meta.created_at', 'asc').get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    snapshot.forEach(doc => {

                        /*
                        **  Add to the prop
                        **  @prop: @here
                        */

                        this.events.push(doc.data());

                    });

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Get Rent Invoice Events in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Invoice',
                        uid: 'SZfLEdhVuRwBUn83OzFB',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Resetting the events prop while getting the invoice events.',
                    errorType: 'Application',
                    section: 'Events/Invoice-Events',
                    uid: 'sbyycfOjgOUPywGhZtYk',
                    error: e
                });

            }

        }

    }

}